import { render } from "./TreeChild.vue?vue&type=template&id=0e04ac98"
import script from "./TreeChild.vue?vue&type=script&lang=js"
export * from "./TreeChild.vue?vue&type=script&lang=js"
script.render = render

export default script